// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"445675c1","239":"d85762ed","732":"a80e2e52"}[chunkId] + ".chunk.js";
};